<template>
  <transition name="historico-fade">
    <div class="historico-overlay" @click.self="$emit('fechar')">
      <transition name="historico-slide">
        <div class="historico-painel">
          <div class="historico-header">
            <h2><i class="bi bi-clock-history"></i> Histórico de conversas</h2>
            <button class="btn-fechar-historico" title="Fechar" @click="$emit('fechar')">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="historico-busca">
            <i class="bi bi-search"></i>
            <input
              type="text"
              v-model="filtro"
              placeholder="Buscar nas conversas..."
              autofocus
            />
          </div>

          <div class="historico-lista">
            <div class="historico-vazio" v-if="carregando">
              <span class="typing"><span></span><span></span><span></span></span>
            </div>

            <div class="historico-vazio" v-else-if="!conversasFiltradas.length">
              <i class="bi bi-chat-square-dots"></i>
              <p>{{ filtro ? 'Nenhuma conversa encontrada.' : 'Você ainda não tem conversas salvas.' }}</p>
            </div>

            <template v-else>
              <template v-for="grupo in gruposVisiveis">
                <div class="historico-grupo-label" :key="'label-' + grupo.label">{{ grupo.label }}</div>
                <button
                  class="historico-item"
                  v-for="conversa in grupo.itens"
                  :key="conversa.nr_sequencial"
                  @click="selecionar(conversa)"
                >
                  <i class="bi" :class="biDaConversa(conversa).icone"></i>
                  <span class="historico-item-texto">
                    <span class="historico-item-titulo">{{ conversa.ds_titulo || 'Conversa sem título' }}</span>
                    <span class="historico-item-bi">{{ biDaConversa(conversa).nome }}</span>
                  </span>
                  <small>{{ tempoRelativo(paraEpoch(conversa.dt_atualizacao)) }}</small>
                </button>
              </template>
            </template>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
import { tempoRelativo } from '@/utils/relatorios'
import { BIS_DISPONIVEIS } from '@/common/api.js'

const BI_DESCONHECIDO = { id: null, nome: 'BI', icone: 'bi-chat-left-text' }

export default {
  name: 'ChatHistorico',
  data() {
    return {
      carregando: true,
      conversas: [],
      filtro: '',
      bisDisponiveis: BIS_DISPONIVEIS
    }
  },
  computed: {
    conversasFiltradas() {
      const termo = this.filtro.trim().toLowerCase()
      if (!termo) return this.conversas

      return this.conversas.filter(c => (c.ds_titulo || '').toLowerCase().includes(termo))
    },
    gruposVisiveis() {
      const agora = new Date()
      const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate())
      const ontem = new Date(hoje); ontem.setDate(hoje.getDate() - 1)
      const seteDias = new Date(hoje); seteDias.setDate(hoje.getDate() - 7)
      const trintaDias = new Date(hoje); trintaDias.setDate(hoje.getDate() - 30)

      const grupos = [
        { label: 'Hoje', itens: [] },
        { label: 'Ontem', itens: [] },
        { label: 'Últimos 7 dias', itens: [] },
        { label: 'Últimos 30 dias', itens: [] },
        { label: 'Mais antigas', itens: [] }
      ]

      this.conversasFiltradas.forEach(conversa => {
        const data = this.paraData(conversa.dt_atualizacao)
        if (!data) return

        if (data >= hoje) grupos[0].itens.push(conversa)
        else if (data >= ontem) grupos[1].itens.push(conversa)
        else if (data >= seteDias) grupos[2].itens.push(conversa)
        else if (data >= trintaDias) grupos[3].itens.push(conversa)
        else grupos[4].itens.push(conversa)
      })

      return grupos.filter(g => g.itens.length)
    }
  },
  methods: {
    tempoRelativo,
    // O Postgres/Laravel devolve timestamp como "2026-08-24 15:32:00" (sem "T"),
    // que alguns navegadores não parseiam bem — normaliza antes de criar o Date.
    paraData(valor) {
      if (!valor) return null
      const normalizado = String(valor).replace(' ', 'T')
      const data = new Date(normalizado)
      return isNaN(data.getTime()) ? null : data
    },
    paraEpoch(valor) {
      const data = this.paraData(valor)
      return data ? data.getTime() : null
    },
    // listarConversasChat() devolve a coluna crua "ds_report_id" (não mapeada
    // pra camelCase, diferente de listarMensagensChat) — casa com o BI certo.
    biDaConversa(conversa) {
      return this.bisDisponiveis.find(bi => bi.reportId === conversa.ds_report_id) || BI_DESCONHECIDO
    },
    selecionar(conversa) {
      this.$emit('abrir-conversa', conversa)
    },
    async carregar() {
      this.carregando = true
      try {
        this.conversas = await this.$store.dispatch('busca/listarConversasChat')
      } catch (error) {
        this.conversas = []
      } finally {
        this.carregando = false
      }
    }
  },
  created() {
    this.carregar()
  }
}
</script>

<style scoped>
.historico-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: stretch;
}

.historico-painel {
  width: 100%;
  max-width: 380px;
  height: 100%;
  background: var(--rd-bg-app, var(--rd-bg-1));
  border-right: 1px solid var(--rd-border-strong);
  display: flex;
  flex-direction: column;
  box-shadow: 12px 0 40px rgba(0, 0, 0, 0.35);
}

.historico-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 18px 12px;
}

.historico-header h2 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--rd-text-1);
  margin: 0;
}

.btn-fechar-historico {
  background: none;
  border: none;
  color: var(--rd-text-3);
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: 0.2s ease;
}

.btn-fechar-historico:hover {
  color: var(--rd-text-1);
  background: var(--rd-hover);
}

.historico-busca {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 18px 14px;
  padding: 9px 12px;
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border);
  border-radius: var(--rd-radius-sm, 10px);
  color: var(--rd-text-3);
}

.historico-busca input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: var(--rd-text-1);
  font-size: 13px;
}

.historico-busca input::placeholder {
  color: var(--rd-text-3);
}

.historico-lista {
  flex: 1;
  overflow-y: auto;
  padding: 0 10px 18px;
}

.historico-grupo-label {
  padding: 12px 8px 6px;
  font-size: 10.5px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--rd-text-3);
}

.historico-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 8px;
  background: none;
  border: none;
  border-radius: var(--rd-radius-sm, 10px);
  color: var(--rd-text-2);
  text-align: left;
  cursor: pointer;
  transition: 0.15s ease;
}

.historico-item:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}

.historico-item i {
  color: var(--rd-text-3);
  font-size: 14px;
}

.historico-item-texto {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.historico-item-titulo {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}

.historico-item-bi {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 10.5px;
  color: var(--rd-text-3);
}

.historico-item small {
  color: var(--rd-text-3);
  font-size: 10.5px;
  white-space: nowrap;
}

.historico-vazio {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 60px 20px;
  color: var(--rd-text-3);
  text-align: center;
}

.historico-vazio i {
  font-size: 26px;
}

.historico-vazio p {
  margin: 0;
  font-size: 13px;
}

.typing {
  display: inline-flex;
  gap: 4px;
}

.typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--rd-text-3);
  animation: historico-piscar 1s infinite ease-in-out;
}

.typing span:nth-child(2) { animation-delay: 0.15s; }
.typing span:nth-child(3) { animation-delay: 0.3s; }

@keyframes historico-piscar {
  0%, 80%, 100% { opacity: 0.2; }
  40% { opacity: 1; }
}

/* Transições */
.historico-fade-enter-active,
.historico-fade-leave-active {
  transition: opacity 0.2s ease;
}

.historico-fade-enter,
.historico-fade-leave-to {
  opacity: 0;
}

.historico-slide-enter-active,
.historico-slide-leave-active {
  transition: transform 0.25s ease;
}

.historico-slide-enter,
.historico-slide-leave-to {
  transform: translateX(-100%);
}
</style>
